






































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { GithubService } from '../services/github.service';

@Component
export default class Profile extends Vue {
  @Prop() private msg!: string;

  user: any;
  username = 'lzwme';
  preUserName = '';
  reposTotalCount = 0;
  repos: any[] = [];
  userList = [
    'lzwme',
    'renxia',
    'fex-team',
    'vuejs',
    'angular',
    'reactjs',
    'facebook',
    'microsoft',
    'google',
    'tencent',
    'alibaba',
    'baidu',
  ];

  isLoading = false;
  timeout = 10000;

  pager = {
    curPage: 0,
    pageSize: 50,
    sort: 'updated',
    direction: 'desc',
    q: '',
  };

  tipTimer;
  tipType;
  msgTip = '';

  get pageList() {
    const page: number[] = [];

    if (!this.user) {
      return page;
    }

    const totalPage = Math.ceil(this.reposTotalCount / this.pager.pageSize);

    for (let i = 0; i < totalPage; i++) {
      page.push(i);
    }

    return page;
  }

  githubService = new GithubService();

  constructor() {
    super();

    this.user = false;
    this.searchUser();
    window['profileComp'] = this;
  }

  searchUserTimer;
  searchUser() {
    const username = String(this.username).trim();

    if (this.isLoading || !username || username === this.preUserName) {
      return;
    }

    this.preUserName = username;
    clearTimeout(this.searchUserTimer);
    this.searchUserTimer = setTimeout(() => {
      this.githubService
        .updateUser(this.username)
        .getUser()
        .then(
          user => {
            this.user = user;
            this.reposTotalCount = user.public_repos;
          },
          error => {
            console.log(error);
            this.showTips(`[getUser][${username}][${error.status}] ` + error.statusText, 'danger');
          }
        );

      this.getReoByPage(1);
    }, 300);
  }

  setUserName(name) {
    this.username = name;
    this.searchUser();
  }

  getReoByPage(page) {
    if (this.isLoading) {
      return;
    }

    this.isLoading = true;
    this.pager.curPage = page;

    // 最长多少 s 取消 loading
    setTimeout(() => (this.isLoading = false), this.timeout);

    const username = this.username;
    // this.githubService.getRepositories(this.pager).then(
    this.githubService.searchRepos(this.pager).then(
      res => {
        this.isLoading = false;
        if (res.items) {
          this.reposTotalCount = res.total_count;
          this.repos = res.items;
          this.showTips('done!');
        }
      },
      error => {
        console.log(error);
        this.isLoading = false;
        this.showTips(`[getRepositories][${username}][${error.status}] ` + error.statusText, 'danger');
      }
    );
  }

  showTips(err, type: 'success' | 'warning' | 'danger' | 'info' = 'success') {
    this.msgTip = err || '';
    this.tipType = type;

    clearTimeout(this.tipTimer);
    this.tipTimer = setTimeout(() => (this.msgTip = ''), 4500);
  }
}
